import axios from 'axios'

let filesToUpdate = 0
let filesUpdated = 0
let arrDownloaded = []

const state = {
  pageItems: [],
  offlineItems: (localStorage.getItem('offlineItems') !== null) ? localStorage.getItem('offlineItems') : null,
  filesMissing: [],
  arrErrors: [],
  needtoupdate: false,
  dataLoaded: false,
  downloadCancelled: false,
  downloadStarted: false,
}

const mutations = {
  UPDATE_PAGE_LIST(state, payload) {
    state.pageItems = payload
    console.log('UPDATE_PAGE_LIST', state.pageItems);
  },
  UPDATE_ERRORS_LIST(state, payload) {
    if (payload) {
      state.arrErrors.push(payload)
    } else {
      state.arrErrors = []
    }
    console.log("UPDATE_ERRORS_LIST =>", state.arrErrors);
  },
  UPDATE_MISSING_LIST(state, payload) {
    if (Array.isArray(payload)) {
      state.filesMissing = payload
    } else if (payload == null) {
      state.filesMissing = []
    } else {
      if (state.filesMissing.indexOf(payload) === -1) {
        state.filesMissing.push(payload)
      }
    }
    //console.log("UPDATE_MISSING_LIST =>", state.filesMissing.length);
  },
  UPDATE_DOWNLOAD_STATE(state, payload) {
    if (payload.cancelled !== undefined) state.downloadCancelled = payload.cancelled
    if (payload.started !== undefined) state.downloadStarted = payload.started
  },
  UPDATE_NEEDED(state, payload) {
    state.needtoupdate = payload
    console.log("UPDATE_NEEDED =>", state.needtoupdate);
  },
  DATA_LOADED(state, payload) {
    if (payload) {
      localStorage.setItem('offlineItems', JSON.stringify(payload))
      state.offlineItems = payload
      state.dataLoaded = true
      if (global.isOffline) {
        window.ipcRenderer.send("updated")
      }
    } else {
      state.dataLoaded = false
    }
    console.log("UPDATE dataLoaded =>", state.dataLoaded);
  },
}

const actions = {
  async getOfflineItems({ commit }) {
    // prelevo dati offline
    let items = localStorage.getItem('offlineItems')
    items = JSON.parse(items)
    //console.log('getOfflineItems', items)
    commit('UPDATE_PAGE_LIST', items)
    commit("DATA_LOADED", items)
    return items
  },
  async getPageItems ({ rootState, rootGetters, commit, dispatch }, checkFiles) {
    //commit('SET_LOADING', true)
    const token = rootGetters['login/token']
    const email = rootGetters['login/email']
    let apiPath = rootState.apiPath
    return axios({
      url: apiPath +'loaditems/',
      method: 'post',
      data: { section: rootState.section, offline: ((global.isOffline) ? 1 : 0), email: email },
      headers: {
          Authorization: `JWT ${token}`
      }
    })
    .then((response) => {
      if (response.data.error) {
        console.log(response.data.error)
        //commit("DATA_LOADED", false)
        return response.data
      } else {
        let items = response.data
        // se offline faccio prima il check dei files
        if (!global.isOffline) {
          commit('UPDATE_PAGE_LIST', items);
          commit("DATA_LOADED", items)
        } else {
          if (checkFiles) return dispatch('checkFiles', items)
        }
        return(items)
      }
    })
    .catch((err) => {
      console.log("GET call unsuccessful :(", err);
      err.error = err.message
      return err
    });
  },
  async checkFiles({ getters, commit, rootGetters }, items) {
    console.log('=> checkFiles')
    commit('UPDATE_ERRORS_LIST', null)
    return new Promise((resolve) => {
      Object.keys(items).forEach(function(itemIndex) {
        let item = items[itemIndex]
        if (item.companyImage && !global.fs.existsSync(item.companyImage.replace('atom://', rootGetters.appPath))) commit('UPDATE_MISSING_LIST', item.companyImage)
        if (item.image1 && !global.fs.existsSync(item.image1.replace('atom://', rootGetters.appPath))) commit('UPDATE_MISSING_LIST', item.image1)
        if (item.image2 && !global.fs.existsSync(item.image2.replace('atom://', rootGetters.appPath))) commit('UPDATE_MISSING_LIST', item.image2)
        if (item.slider) {
          Object.keys(item.slider).forEach(function(sliderIndex) {
            let slider = item.slider[sliderIndex]
            if (!global.fs.existsSync(slider.src.replace('atom://', rootGetters.appPath))) commit('UPDATE_MISSING_LIST', slider.src)
          })
          /*if (item.company.mainImg) item.company.mainImg = publicPath + item.company.mainImg
          if (item.company.mainVideo && item.company.mainVideo.substr(0, 5) !== "https") item.company.mainVideo = publicPath + item.company.mainVideo*/
        }
        if (item.documents) {
          Object.keys(item.documents).forEach(function(docIndex) {
            let document = item.documents[docIndex]
            if (!global.fs.existsSync(document.src.replace('docs://', rootGetters.appPath))) commit('UPDATE_MISSING_LIST', document.src)
          })
        }
        if (item.gamma) {
          Object.keys(item.gamma).forEach(function(gammaIndex) {
            let gammaItem = item.gamma[gammaIndex]
            //console.log(gammaItem)
            if (gammaItem.profile && !global.fs.existsSync(gammaItem.profile.replace('atom://', rootGetters.appPath))) commit('UPDATE_MISSING_LIST', gammaItem.profile)
            if (gammaItem.mainImg && !global.fs.existsSync(gammaItem.mainImg.replace('atom://', rootGetters.appPath))) commit('UPDATE_MISSING_LIST', gammaItem.mainImg)
            if (gammaItem.videoCover && !global.fs.existsSync(gammaItem.videoCover.replace('atom://', rootGetters.appPath))) commit('UPDATE_MISSING_LIST', gammaItem.videoCover)
            if (gammaItem.mainVideo && !global.fs.existsSync(gammaItem.mainVideo.replace('atom://', rootGetters.appPath))) commit('UPDATE_MISSING_LIST', gammaItem.mainVideo)
            //if (gammaItem.gallerycover && !global.fs.existsSync(gammaItem.gallerycover.replace('atom://', rootGetters.appPath))) commit('UPDATE_MISSING_LIST', gammaItem.gallerycover)
            if (gammaItem.gallerycover && !global.fs.existsSync(gammaItem.gallerycover.replace('atom://', rootGetters.appPath))) commit('UPDATE_MISSING_LIST', gammaItem.gallerycover)
            if (gammaItem.interiors) {
              Object.keys(gammaItem.interiors).forEach(function(galleryIndex) {
                let interiorItem = gammaItem.interiors[galleryIndex]
                if (!global.fs.existsSync(interiorItem.src.replace('atom://', rootGetters.appPath))) commit('UPDATE_MISSING_LIST', interiorItem.src)
                if (!global.fs.existsSync(interiorItem.thumb.replace('atom://', rootGetters.appPath))) commit('UPDATE_MISSING_LIST', interiorItem.thumb)
              })
            }
            if (gammaItem.exteriors) {
              Object.keys(gammaItem.exteriors).forEach(function(galleryIndex) {
                let exteriorItem = gammaItem.exteriors[galleryIndex]
                if (!global.fs.existsSync(exteriorItem.src.replace('atom://', rootGetters.appPath))) commit('UPDATE_MISSING_LIST', exteriorItem.src)
                if (!global.fs.existsSync(exteriorItem.thumb.replace('atom://', rootGetters.appPath))) commit('UPDATE_MISSING_LIST', exteriorItem.thumb)
              })
            }
            if (gammaItem.videos) {
              Object.keys(gammaItem.videos).forEach(function(galleryIndex) {
                let videoItem = gammaItem.videos[galleryIndex]
                if (!global.fs.existsSync(videoItem.src.replace('atom://', rootGetters.appPath))) commit('UPDATE_MISSING_LIST', videoItem.src)
              })
            }
            if (gammaItem.layout) {
              Object.keys(gammaItem.layout).forEach(function(arrIndex) {
                let layoutItem = gammaItem.layout[arrIndex]
                if (!global.fs.existsSync(layoutItem.src.replace('atom://', rootGetters.appPath))) commit('UPDATE_MISSING_LIST', layoutItem.src)
              })
            }
            if (gammaItem.docs) {
              Object.keys(gammaItem.docs).forEach(function(docsIndex) {
                let docItem = gammaItem.docs[docsIndex]
                Object.keys(docItem).forEach(function(docIndex) {
                  let doc = docItem[docIndex]
                  if (!global.fs.existsSync(doc.src.replace('docs://', rootGetters.appPath))) commit('UPDATE_MISSING_LIST', doc.src)
                  //doc.src = doc.src.replace('docs://', rootGetters.appPath)
                })
                //console.log(docsIndex, docItem)
              })
            }
          })
        }
      })
      //console.log(items)
      filesToUpdate = getters.filesMissing.length
      commit('UPDATE_PAGE_LIST', items);
      if (filesToUpdate == 0) {
        commit("DATA_LOADED", items)
      } else {
        commit("UPDATE_NEEDED", true)
      }
      resolve(items)
    })
  },
  cancelDownload({ commit, dispatch }) {
    console.log("!!! cancelDownload !!!")
    commit('UPDATE_DOWNLOAD_STATE', { started: false, cancelled: true })
    window.ipcRenderer.send("disconnectFtp")
    dispatch('checkUpdating')
  },
  updateFiles({ getters, dispatch, commit }) {
    commit('UPDATE_DOWNLOAD_STATE', { started: true, cancelled: false })
    dispatch('resetCounters')
    const resultBox = document.getElementById('result')
    resultBox.innerHTML = "Downloadding updates..."

    dispatch('startDownload', getters.filesMissing)
    .then(() => {
      dispatch('checkUpdating')
    })
    .catch((error) => {
        console.log(error);
        //return false
    });
    
  },
  checkUpdating({ getters, dispatch, commit }) {
    //console.log('*** checkUpdating ***')
    filesUpdated = arrDownloaded.length
    let filesTot = filesUpdated
    if (getters.arrErrors.length) filesTot += getters.arrErrors.length
    //console.log('filesToUpdate: '+ filesToUpdate +' filesUpdated: '+ filesUpdated)
    //console.log('filesTot: '+ filesTot +' files with errors: '+ getters.arrErrors.length)
    const resultBox = document.getElementById('result')
    resultBox.innerHTML = "Downloaded "+ filesUpdated +' / '+ filesToUpdate
    // reset in caso di cancellazione
    if (getters.downloadCancelled) {
      console.log('Download interrupted by user => ricarico missing list')
      resultBox.innerHTML = 'Download interrupted by user'
      commit('UPDATE_MISSING_LIST', null)
      dispatch('resetCounters')
      dispatch('checkFiles', getters.pageItems)
      return
    }
    if (filesToUpdate == filesTot) {
      console.log("downloaded All")
      commit('UPDATE_DOWNLOAD_STATE', { started: false, cancelled: false })
      if (getters.arrErrors.length) {
        commit('UPDATE_MISSING_LIST', null)
        commit('UPDATE_MISSING_LIST', getters.arrErrors)
        commit("UPDATE_NEEDED", true)
      } else {
        commit("UPDATE_NEEDED", false)
        commit('UPDATE_MISSING_LIST', null)
        commit("DATA_LOADED", getters.pageItems)
        resultBox.innerHTML = "Ready to start"
      }
      return true
    }
  },
  async startDownload({ getters, dispatch, commit }, payload) {
    console.log("************ startDownload ******************")
    return new Promise((resolve, reject) => {
      window.ipcRenderer.send("downloadFiles", JSON.stringify(payload))
      window.ipcRenderer.on('FTPmessage', (event, data) => {
        if (getters.filesMissing.length) {
          document.getElementById('result').innerHTML = data
        }
      })
      window.ipcRenderer.on('downloadResult', (event, data) => {
        if (arrDownloaded.indexOf(data.path) == -1) {
          arrDownloaded.push(data.path)
          dispatch('checkUpdating')
        }
        resolve({ path: data.path, filesUpdated: filesUpdated })
      })
      window.ipcRenderer.on('downloadError', (event, data) => {
        if (getters.arrErrors.indexOf(data.path) == -1) {
          //console.log('ERROR downloading '+ data.path +' from ipcRenderer')
          commit('UPDATE_ERRORS_LIST', data.path)
          document.getElementById('errormsg').innerHTML = data.error
          dispatch('checkUpdating')
        }
        reject('downloadError: '+ data.error)
      })
    });
  },
  resetCounters({ commit, getters }) {
    console.log("*** resetCounters ***")
    const resultBox = document.getElementById('result')
    resultBox.innerHTML = ""
    filesUpdated = 0
    arrDownloaded = []
    commit('UPDATE_ERRORS_LIST', null)
    filesToUpdate = getters.filesMissing.length
    //filesToUpdate = 10 // test
  }
}

const getters = {
  dataLoaded: (state) => state.dataLoaded,
  pageItems: (state) => state.pageItems,
  offlineItems: (state) => state.offlineItems,
  filesMissing: (state) => state.filesMissing,
  needtoupdate: (state) => state.needtoupdate,
  downloadCancelled: (state) => state.downloadCancelled,
  downloadStarted: (state) => state.downloadStarted,
  arrErrors: (state) => state.arrErrors,
  pagesFromSection: (state) => (section) => {
    if (!state.pageItems) return null
    if (process.env.NODE_ENV == 'development') console.log("pagesFromSection - section: "+ section);
    let sectionItems
    Object.keys(state.pageItems).forEach(function(itemIndex) {
      let sectionItem = state.pageItems[itemIndex]
      if (sectionItem.section == section) {
        if (process.env.NODE_ENV == 'development') console.log('company items found', sectionItem.title)
        sectionItems = sectionItem
      }
    })
    return sectionItems
  },
  pageItemFromId: (state, commit, dispatch, rootState) => (sectionPage, id) => {
    if (!state.pageItems) return null
    if (process.env.NODE_ENV == 'development') console.log("pageItemFromId - section: "+ rootState.section +" Id: "+ id );
    let page
    Object.keys(sectionPage.gamma).forEach(function(itemIndex) {
      let gammaItem = sectionPage.gamma[itemIndex]
      if (gammaItem.id == id) {
        if (process.env.NODE_ENV == 'development') console.log('yacht page found', gammaItem.title)
        page = gammaItem
      }
    })
    return page
  },
}

const filelistModule = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}

export default filelistModule

